<template>
  <Head :title="__('news.meta.title')">
    <meta
      name="description"
      :content="__('news.meta.description')"
    >
    <link
      rel="canonical"
      :href="localeRoute('frontend.news.index')"
    >
    <meta
      property="og:image"
      content="/frontend/assets/favicon/og-image.jpg"
    >
  </Head>

  <section class="blog-hero py-8 relative z-10">
    <img
      src="/frontend/assets/desktop-hero-swirl.svg"
      class="absolute top-0 left-0 hidden lg:block"
    >

    <div class="container">
      <div class="text-center px-8">
        <h1 class="text-5xl font-bold lg:text-7xl">
          {{ __('news.title') }}
        </h1>

        <p class="text-gray-400 mt-2 lg:text-xl lg:mb-8">
          {{ __('news.text') }}
        </p>
      </div>
    </div>

    <div class="w-full absolute px-[15px] md:left-1/2 md:transform md:-translate-x-1/2 md:w-[450px] lg:w-[550px]">
      <div class="relative">
        <img
          src="/frontend/assets/input-zoom.svg"
          class="absolute left-[16px] top-[15px] lg:top-[18px] lg:left-[20px]"
        >

        <input
          v-model="search"
          type="search"
          class="w-full py-[13px] text-lg rounded-xl shadow-input placeholder-gray-250 border-red border-2 focus:ring-red-900 focus:ring-offset-red-900 focus:border-red-900 pl-12 lg:py-4"
          placeholder="Zoeken op blog artikelen"
          @input="searchHandler"
        >
      </div>
    </div>
  </section>

  <section class="blogs relative pt-24 pb-12 bg-white lg:py-36">
    <div class="container">
      <div class="text-center">
        <h2 class="text-4xl font-bold text-center sparkle-only-left inline-block lg:text-5xl">
          {{ __('news.articles.title') }}
        </h2>
      </div>

      <div class="w-auto flex flex-nowrap whitespace-nowrap overflow-x-auto text-gray-300 mt-4 md:mt-12 -mr-[16px] md:-mr-0 border-b border-gray-300 md:w-full md:justify-between">
        <Link
          class="ml-2 mr-1 inline-block py-2 px-3 hover:underline lg:text-xl text-red"
          :href="localeRoute('frontend.news.index')"
        >
          {{ __('news.articles.all') }}
        </Link>

        <Link
          v-for="(newsCategory, i) in newsCategories"
          :key="`news-category-${i}`"
          class="ml-2 mr-1 inline-block py-2 px-3 hover:underline lg:text-xl"
          :href="localeRoute('frontend.categories.slug', [newsCategory.slug])"
        >
          {{ newsCategory.name }}
        </Link>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mt-6">
        <NewsItem
          v-for="(newsItem, i) in filteredNewsItems"
          :key="`news-item-${i}`"
          :news="newsItem"
        />
      </div>
      <div
        v-show="filteredNewsItems.length === 0"
        class="text-center text-2xl lg:text-5xl mt-4 md:mt-8"
      >
        {{ __('news.articles.nothing') }}
      </div>
    </div>
  </section>
</template>

<script>
import debounce from 'lodash/debounce';
import NewsItem from '../../Components/NewsItem.vue';

export default {
  components: {
    NewsItem,
  },

  props: {
    newsCategories: {
      type: Array,
      required: true,
    },

    newsItems: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      page: 1,
      filteredNewsItems: [],

      search: '',
    };
  },

  created() {
    this.searchHandler = debounce(this.searchHandler, 100);
  },

  mounted() {
    this.searchHandler();
  },

  methods: {
    searchHandler() {
      this.filteredNewsItems = this.newsItems
        .filter((newsItem) => {
          const search = this.search.toLowerCase();
          return newsItem.title.toLowerCase().includes(search) || newsItem.excerpt.toLowerCase().includes(search);
        });
    },
  },
};
</script>
